import React from "react";
import { PayPalButtons } from "@paypal/react-paypal-js";
import { postMasterToken } from "../../../../Utils/restUtils";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

function Paypal({ cart, setLoading }) {
  const navigate = useNavigate();

  return (
    <PayPalButtons
      forceReRender={[cart?.coupon_code, cart?.package_id, cart?.company_id, cart?.total]}
      style={{
        layout: "vertical",
        color: "blue",
        shape: "rect",
        label: "pay",
        height: 48,
      }}
      createOrder={async () => {
        setLoading(true)
        try {
          // Create PayPal order from backend
          const response = await postMasterToken("paypal/create-subscription-order", {
            package_id: cart.package_id,
            company_id: cart.company_id,
            coupon_code: cart.coupon_code,
          });

          // API wrapper structure: { status: true, data: { id: "ORDER_ID" } }
          if (response && response.status === 200 && response.data.status === true) {
            setLoading(false)
            return response.data.data.id;
          } else {
            const errorMsg = response?.data?.message || "Failed to create PayPal order.";
            toast.error(errorMsg);
            throw new Error(errorMsg);
          }
        } catch (error) {
          setLoading(false)
          throw error;
        }

      }}
      onApprove={async (data) => {
        setLoading(true)
        try {
          const response = await postMasterToken("paypal/capture-subscription-order", {
            paypal_order_id: data.orderID,
          });

          if (response && response.status === 200 && response.data.status === true) {
            toast.success(response.data.message || "Payment completed successfully!");
            setLoading(false)
            navigate('/billSuccess', { state: { payment_id: response?.data?.data } });
          } else {

            setLoading(false)
            toast.error(response?.data?.message || "Payment verification failed.");
          }
        } catch (error) {
          toast.error("Payment verification failed.");
          setLoading(false)
        }
        setLoading(false)
      }}
      onCancel={() => {
        toast.info("Payment cancelled.");
      }}
      onError={(err) => {
        toast.error("PayPal checkout error.");
      }}
    />
  );
}

export default Paypal;